import { DataType } from '@/domains/base/enums/data-type';
/**
 * 存储文件夹中FolderList的展开状态Key的前缀
 * 原来的规则是：'folder-status-' + spaceId
 * 新的逻辑兼容老数据
 */
export const FOLDER_STATUS_LOCAL_PREFIX_KEY = 'folder-status-';
/**
 * DataType与folderItem中DataCount字段的映射关系
 */
export const DATA_TYPE_FOLDER_ITEM_DATA_COUNT_MAP = {
    [DataType.PATENT]: 'patent_count',
    [DataType.PAPER]: 'paper_count',
    [DataType.MARKET]: 'mr_count',
    [DataType.INVESTMENT]: 'vc_count',
    [DataType.MERGER]: 'ma_count',
    [DataType.BIO]: 'bio_count',
    [DataType.DRUG]: 'drug_count',
    [DataType.CLINICAL]: 'clinical_count',
    [DataType.CLINICAL_RESULT]: 'clinical_trial_result_count',
};
/**
 * FolderList 根节点标识
 */
export const ROOT_FOLDER_ID = '-root';
/**
 * Folder上可编辑的属性
 */
export const FOLDER_EDITABLE_FIELDS = ['folder_name', 'folder_desc', 'folder_auto_update'];
